import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TargetGroupEnumTranslations } from '@app/admin/target-group/target-group-enum-translations';

@Component({
  selector: 'flow-media-stats-item',
  templateUrl: './media-stats-item.component.html',
  styleUrls: ['./media-stats-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaStatsItemComponent implements OnChanges {
  @Input() tooltip: string;
  @Input() value: number | string;
  @Input() valueTooltip?: string;
  @Input() label: string;
  @Input() dropdownList: string[];
  targetGroups: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.dropdownList?.currentValue) {
      this.targetGroups = changes?.dropdownList?.currentValue.map(item => TargetGroupEnumTranslations[item]);
    }
  }
}
